<template>
  <div class="cualitativo-container">
    <div class="form">
      <el-container>
        <el-main>
          <el-form
            :model="form"
            ref="refId"
            :rules="rules"
            @presubmit.prevent
          >
            <div style="margin-top:20px;">
              <p class="label-style">CUALITATIVO</p>
              <div class="row-no-center" style="margin-top: 15px;">
                <el-form-item
                  prop="familySituationDescription"
                  class="large"
                  label="Descripción de la situación familiar"
                >
                  <el-input
                    v-model="form.familySituationDescription"
                    type="textarea"
                    :autosize="{ minRows: 3}"
                  />
                </el-form-item>
                <el-form-item
                  prop="comments"
                  class="large"
                  label="Comentarios de la Trabajodora Social"
                >
                  <el-input
                    v-model="form.comments"
                    type="textarea"
                    :autosize="{ minRows: 3}"
                  />
                </el-form-item>
              </div>
              <div class="perfil-container">
                <p class="label-style">PERFIL</p>
                <el-form-item
                  class="medium"
                  label="Clasificación"
                  style="margin-top:10px;"
                >
                  <el-select v-model="form.classification">
                    <el-option
                      v-for="item in perfilOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item
                class="medium"
                label="Evaluación de Trabajadora Social"
                style="margin-top:10px;"
                prop="evaluationResult"
              >
                <el-select v-model="form.evaluationResult">
                  <el-option
                    v-for="item in evaluationResult"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <div v-if="form.evaluationResult === evaluationResult[1].value">
                <el-form-item
                  class="medium"
                  label="Área"
                  style="margin-top:10px;"
                >
                  <el-select v-model="form.area">
                    <el-option
                      v-for="item in optionsClasifica"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="form.area === 'cirugia'"
                  class="medium"
                  label="Costo"
                  style="margin-top:10px;"
                >
                  <el-select v-model="form.cost">
                    <el-option
                      v-for="item in optionsCosto"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <div class="options-conCosto">
                  <el-form-item
                    v-if="form.cost === 'con costo' && form.area === 'cirugia'"
                    class="medium"
                    label="Moneda"
                    style="margin-top:10px;"
                  >
                    <el-select v-model="form.currency">
                      <el-option
                        v-for="item in optionsMoneda"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              <div
                class="cirugia"
                v-if="form.cost === 'sin costo' && form.area === 'cirugia'
                  || (form.cost === 'con costo')"
              >
                <div class="cirugia-card">
                  <Cirugias
                    :costo="form.cost"
                    :currency="form.currency"
                    :idAppointment="idAppointment"
                  />
                </div>
              </div>
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              @click="updateCualitative(form.patientId)"
              style="background-color: #6a41bdca;"
              >
                Guardar Datos Cualitativos
            </el-button>
            <el-form-item style="width: 100%!important;">
              <el-button
                type="success"
                @click="docsVisible = true"
                class="files"
                style="margin-left:0px; float:right; margin-right:10px"
              >
                ADJUNTAR ARCHIVOS
              </el-button>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import optionsMixin from '../../views/evaluations/SocioEconomic/mixin/options';
import Cirugias from './components/cirugias';
import currencyFormater from '../../utils/currencyFormater';

export default {
  props: {
    idAppointment: {
      type: Number,
      default: null,
    },
  },
  data() {
    const isDecimal = (rule, value, cb) => {
      const regexp = /^[0-9]+([,.][0-9]+)?$/g;
      if (value && !regexp.test(value)) {
        return cb(new Error('El campo debe ser un numero decimal.'));
      }
      return cb();
    };
    return {
      perfilOptions: [
        {
          value: 'A/B+',
          label: 'A/B+',
        },
        {
          value: 'C+',
          label: 'C+',
        },
        {
          value: 'C',
          label: 'C',
        },
        {
          value: 'D+',
          label: 'D+',
        },
        {
          value: 'D',
          label: 'D',
        },
        {
          value: 'E',
          label: 'E',
        },
      ],
      optionsClasifica: [
        {
          label: 'Cirugía',
          value: 'cirugia',
        },
        {
          label: 'Atención',
          value: 'atención',
        },
      ],
      optionsCosto: [
        {
          label: 'Con Costo',
          value: 'con costo',
        },
        {
          label: 'Sin Costo',
          value: 'sin costo',
        },
      ],
      optionsMoneda: [
        {
          label: 'USD',
          value: 'USD',
        },
        {
          label: 'MXN',
          value: 'MXN',
        },
      ],
      form: {
        patientId: null,
        motivoEvaluacion: null,
        residenceTimeAtTijuana: null,
        academicDegree: null,
        houseCodition: null,
        houseWalls: null,
        houseFloor: null,
        houseRoof: null,
        houseRoomsLivingRoom: false,
        houseRoomsDiningRoom: false,
        houseRoomsKitchen: false,
        houseRoomsBathroom: null,
        houseRoomsBathroomQuantity: null,
        houseRoomsBedroom: 0,
        houseRoomsStudyingRoom: false,
        houseRoomsCourtyard: false,
        houseRoomsOther: false,
        serviceLight: false,
        serviceSewerSystem: false,
        serviceCableTV: false,
        servicePhone: false,
        serviceInternet: false,
        serviceAsphaltStreet: false,
        servicePublicWater: false,
        serviceOther: false,
        houseStuffFridge: false,
        houseStuffStove: false,
        houseStuffMicrowaveOven: false,
        houseStuffBlender: false,
        houseStuffWashingMachine: false,
        houseStuffDryer: false,
        houseStuffComputer: false,
        houseStuffDiningRoomSet: false,
        houseStuffLivingRoomSet: false,
        houseStuffBedroomSet: false,
        houseStuffTV: false,
        houseStuffDishWasher: false,
        car: null,
        expenseWater: null,
        expenseLight: null,
        expensePhone: null,
        expenseCellPhone: null,
        expenseGas: null,
        expenseFood: null,
        expenseHouseSupplies: null,
        expenseHealth: null,
        expenseSupport: null,
        expenseEducation: null,
        expenseRent: null,
        expenseTransport: null,
        expenseCreditCard: null,
        expenseOther: null,
        incomeReceipts: null,
        outcomeReceipts: null,
        familySituationDescription: null,
        comments: null,
        evaluationResult: null,
        programApplied: null,
        perfil: null,
        currency: 'USD',
        precio: null,
        cost: null,
        area: null,
        classification: null,
      },
      rules: {
        expenseWater: [
          {
            validator: isDecimal,
          },
        ],
        expenseLight: [
          {
            validator: isDecimal,
          },
        ],
        expensePhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseCellPhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseGas: [
          {
            validator: isDecimal,
          },
        ],
        expenseFood: [
          {
            validator: isDecimal,
          },
        ],
        expenseHouseSupplies: [
          {
            validator: isDecimal,
          },
        ],
        expenseHealth: [
          {
            validator: isDecimal,
          },
        ],
        expenseSupport: [
          {
            validator: isDecimal,
          },
        ],
        expenseEducation: [
          {
            validator: isDecimal,
          },
        ],
        expenseRent: [
          {
            validator: isDecimal,
          },
        ],
        expenseTransport: [
          {
            validator: isDecimal,
          },
        ],
        expenseCreditCard: [
          {
            validator: isDecimal,
          },
        ],
        expenseOther: [
          {
            validator: isDecimal,
          },
        ],

      },
      loadingService: null,
      loading: false,
      hasSelfOccupation: false,
      anteriorValue: 0,
    };
  },
  mixins: [optionsMixin],
  components: {
    Cirugias,
  },
  methods: {
    format() {
      return {
        patient: this.form.patientId,
        evaluationId: this.form.evaluationId,
        motivoEvaluacion: this.form.motivoEvaluacion,
        residenceTimeAtTijuana: this.form.residenceTimeAtTijuana,
        academicDegree: this.form.academicDegree,
        houseCondition: this.form.houseCondition,
        houseWalls: this.form.houseWalls,
        houseFloor: this.form.houseFloor,
        houseRoof: this.form.houseRoof,
        houseRoomsLivingRoom: this.form.houseRoomsLivingRoom,
        houseRoomsDiningRoom: this.form.houseRoomsDiningRoom,
        houseRoomsKitchen: this.form.houseRoomsKitchen,
        houseRoomsBathroom: this.form.houseRoomsBathroom,
        // houseRoomsBathroomQuantity: this.bathroom ? this.form.houseRoomsBathroomQuantity : null,
        houseRoomsBedroom: this.houseRoomsBedroom ? this.form.houseRoomsBedroom : null,
        houseRoomsStudyingRoom: this.form.houseRoomsStudyingRoom,
        houseRoomsCourtyard: this.form.houseRoomsCourtyard,
        houseRoomsOther: this.form.houseRoomsOther,
        serviceLight: this.form.serviceLight,
        serviceSewerSystem: this.form.serviceSewerSystem,
        serviceCableTV: this.form.serviceCableTV,
        servicePhone: this.form.servicePhone,
        serviceInternet: this.form.serviceInternet,
        serviceAsphaltStreet: this.form.serviceAsphaltStreet,
        servicePublicWater: this.form.servicePublicWater,
        serviceGaslp: this.form.serviceGaslp,
        serviceOther: this.form.serviceOther,
        houseStuffFridge: this.form.houseStuffFridge,
        houseStuffStove: this.form.houseStuffStove,
        houseStuffMicrowaveOven: this.form.houseStuffMicrowaveOven,
        houseStuffBlender: this.form.houseStuffBlender,
        houseStuffWashingMachine: this.form.houseStuffWashingMachine,
        houseStuffDryer: this.form.houseStuffDryer,
        houseStuffComputer: this.form.houseStuffComputer,
        houseStuffDiningRoomSet: this.form.houseStuffDiningRoomSet,
        houseStuffLivingRoomSet: this.form.houseStuffLivingRoomSet,
        houseStuffBedroomSet: this.form.houseStuffBedroomSet,
        houseStuffTV: this.form.houseStuffTV,
        houseStuffDishWasher: this.form.houseStuffDishWasher,
        car: this.form.car,
        expenseWater: parseFloat(this.form.expenseWater),
        expenseLight: parseFloat(this.form.expenseLight),
        expensePhone: parseFloat(this.form.expensePhone),
        expenseCellPhone: parseFloat(this.form.expenseCellPhone),
        expenseGas: parseFloat(this.form.expenseGas),
        expenseFood: parseFloat(this.form.expenseFood),
        expenseHouseSupplies: parseFloat(this.form.expenseHouseSupplies),
        expenseHealth: parseFloat(this.form.expenseHealth),
        expenseSupport: parseFloat(this.form.expenseSupport),
        expenseEducation: parseFloat(this.form.expenseEducation),
        expenseRent: parseFloat(this.form.expenseRent),
        expenseTransport: parseFloat(this.form.expenseTransport),
        expenseCreditCard: parseFloat(this.form.expenseCreditCard),
        expenseOther: parseFloat(this.form.expenseOther),
        incomeReceipts: this.form.incomeReceipts,
        outcomeReceipts: this.form.outcomeReceipts,
        familySituationDescription: this.form.familySituationDescription,
        comments: this.form.comments,
        evaluationResult: this.form.evaluationResult,
        programApplied: this.form.evaluationResult === this.evaluationResult[1].value
          ? this.form.programApplied : null,
        cost: this.form.cost,
        classification: this.form.classification,
        currency: this.form.currency,
        area: this.form.area,
      };
    },
    currencyFormater,
    async getData(patientId) {
      try {
        const response = await this.axios.get(`patient/newsocial/details/${patientId}`);
        if (response.data.appointmentId === this.idAppointment) {
          this.isFirstEvaluation = false;
        } else {
          this.isFirstEvaluation = true;
        }
        if (response.data) {
          const { data } = response;
          this.evaluationId = data.id;
          this.form = data;
          this.createdAt = data?.createdAt;
          const { houseRoomsBedroom } = data;
          this.houseRoomsBedroom = !!houseRoomsBedroom;
          this.form.houseRoomsBedroom = houseRoomsBedroom;

          const formClone = JSON.parse(JSON.stringify(this.form));
          this.initialForm = formClone;
          this.form.patientId = patientId;
        } else if (this.idAppointment.length <= 0) {
          this.open(patientId);
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
    async updateCualitative(patientId) {
      try {
        const data = this.format();
        const request = await this.axios.put(`patient/newsocial/${patientId}/${this.idAppointment}`, data);

        if (request.data) {
          this.axios.post(`patient/changelog/${patientId}`, {
            title: 'EVALUACIÓN SOCIOECONÓMICA',
            message: 'Se modificó el perfil socioeconómico',
          });
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se modificó el perfil socioeconómico',
          });
        } else {
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Guardado con Éxito',
          });
        }
        await this.getData(patientId);
      } catch (error) {
        // console.log(error);
      }
    },
    async updateSurgey() {
      try {
        const patientId = this.$route.params.id;
        const data = this.format();
        const request = this.axios.put(`patient/newSocial/${patientId}/${this.idAppointment}`, data);
        if (request) {
          this.loading = false;
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se han actualizado los datos correctamente',
          });
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
  async created() {
    const { id } = this.$route.params;
    this.form.patientId = id;
    await this.getData(id);
  },
};
</script>

<style lang="scss">
@import '../../views/evaluations/SocioEconomic/styles/style.scss';
.cirugia {
  margin: 20px 0px 20px 20px;
}
</style>
<style lang="scss" scoped>
@import '../../views/evaluations/SocioEconomic/styles/style-scoped.scss';
</style>
